export default __webpack_public_path__ + "3df3cf20c70cd91415a778eca92c0a33.png";